import React from "react";
import {
  Modal,
  Paper,
  Typography,
  Button,
  IconButton,
  Box,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import MissingPersonalData from "../../../assets/images/MissingPersonalData.svg";
import { styles } from "./MissingDataPopupStyles";

interface Props extends WithStyles<typeof styles> {
  open: boolean;
  onClose: () => void;
  onGoToProfile: () => void;
  userName?: string;
}

const MissingDataPopup: React.FC<Props> = ({
  classes,
  open,
  onClose,
  onGoToProfile,
  userName,
}) => {
  return (
    <Modal open={open} onClose={onClose} className={classes.modal}>
      <Paper className={classes.paper}>
        <IconButton
          className={classes.closeButton}
          onClick={onClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>

        <Typography className={classes.greeting}>¡Hola {userName}!</Typography>

        <Box display="flex" justifyContent="center">
          <img
            src={MissingPersonalData}
            alt="Missing Personal Data"
            className={classes.icon}
          />
        </Box>

        <Typography className={classes.message}>
          Por favor, revisa tus datos y confirma que son correctos para
          continuar.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onGoToProfile}
          fullWidth
        >
          Ir a Mi Cuenta
        </Button>
      </Paper>
    </Modal>
  );
};

export default withStyles(styles)(MissingDataPopup);
